import { type ReactNode, useCallback } from 'react'

import { cn } from '@/lib/utils'

const VIDEO_START_POSITION = 0.25

interface AuthBackgroundVideoProps {
  src: string
  className?: string
}

/** Fullscreen background video that covers its parent container. */
export const AuthBackgroundVideo: React.FC<AuthBackgroundVideoProps> = ({
  src,
  className,
}): ReactNode => {
  const videoRef = useCallback((el: HTMLVideoElement | null) => {
    if (!el) return
    el.muted = true

    const startFromQuarter = () => {
      el.currentTime = el.duration * VIDEO_START_POSITION
      el.play()
    }

    if (el.readyState >= HTMLMediaElement.HAVE_METADATA) {
      startFromQuarter()
      return
    }

    el.addEventListener('loadedmetadata', startFromQuarter, { once: true })
  }, [])

  return (
    <video
      ref={videoRef}
      className={cn(
        'auth-background-video absolute inset-0 h-full w-full object-cover object-bottom',
        className
      )}
      src={src}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      tabIndex={-1}
    />
  )
}
